import { createSlice } from '@reduxjs/toolkit'
import DivisionsServices from '../../services/divisionsServices';

const initialState = {
  divisions: []
};

const divisionsSlice = createSlice({
  name: 'divisions',
  initialState,
  reducers: {
    divisionsLoaded(state, action) {
      state.divisions = action.payload;
    }
  },
})

export const { divisionsLoaded } = divisionsSlice.actions;

export default divisionsSlice.reducer;

export const fetchDivisionsList = () => async (dispatch) => {

  try {
    const respData = await DivisionsServices.getDivisions({});
    if (respData.success) {
      const divisionsList = respData.responseObject.value.divisionListDTO;      

      if(divisionsList){
        const objectsArray = divisionsList.map((item) => ({ value: item.id, label: item.name }));
        dispatch(divisionsLoaded(objectsArray));
      }
    }
  } catch (error) {
    console.error('Failed to fetch:', error.message);
  }
};

